import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// zh-TW domain imports
import zhTWCommon from './locales/zh-TW/common.json';
import zhTWAuth from './locales/zh-TW/auth.json';
import zhTWNavigation from './locales/zh-TW/navigation.json';
import zhTWVendor from './locales/zh-TW/vendor.json';
import zhTWUser from './locales/zh-TW/user.json';
import zhTWDashboard from './locales/zh-TW/dashboard.json';
import zhTWMachine from './locales/zh-TW/machine.json';
import zhTWProduct from './locales/zh-TW/product.json';
import zhTWOrder from './locales/zh-TW/order.json';
import zhTWLocation from './locales/zh-TW/location.json';
import zhTWMaintenance from './locales/zh-TW/maintenance.json';
import zhTWAnnouncement from './locales/zh-TW/announcement.json';
import zhTWUpdateLog from './locales/zh-TW/updateLog.json';
import zhTWPayment from './locales/zh-TW/payment.json';
import zhTWSystem from './locales/zh-TW/system.json';

// en-US domain imports
import enCommon from './locales/en-US/common.json';
import enAuth from './locales/en-US/auth.json';
import enNavigation from './locales/en-US/navigation.json';
import enVendor from './locales/en-US/vendor.json';
import enUser from './locales/en-US/user.json';
import enDashboard from './locales/en-US/dashboard.json';
import enMachine from './locales/en-US/machine.json';
import enProduct from './locales/en-US/product.json';
import enOrder from './locales/en-US/order.json';
import enLocation from './locales/en-US/location.json';
import enMaintenance from './locales/en-US/maintenance.json';
import enAnnouncement from './locales/en-US/announcement.json';
import enUpdateLog from './locales/en-US/updateLog.json';
import enPayment from './locales/en-US/payment.json';
import enSystem from './locales/en-US/system.json';

// es-ES domain imports
import esESCommon from './locales/es-ES/common.json';
import esESAuth from './locales/es-ES/auth.json';
import esESNavigation from './locales/es-ES/navigation.json';
import esESVendor from './locales/es-ES/vendor.json';
import esESUser from './locales/es-ES/user.json';
import esESDashboard from './locales/es-ES/dashboard.json';
import esESMachine from './locales/es-ES/machine.json';
import esESProduct from './locales/es-ES/product.json';
import esESOrder from './locales/es-ES/order.json';
import esESLocation from './locales/es-ES/location.json';
import esESMaintenance from './locales/es-ES/maintenance.json';
import esESAnnouncement from './locales/es-ES/announcement.json';
import esESUpdateLog from './locales/es-ES/updateLog.json';
import esESPayment from './locales/es-ES/payment.json';
import esESSystem from './locales/es-ES/system.json';


const resources = {
  'zh-TW': {
    translation: Object.assign(
      {},
      zhTWCommon, zhTWAuth, zhTWNavigation, zhTWVendor, zhTWUser,
      zhTWDashboard, zhTWMachine, zhTWProduct, zhTWOrder, zhTWLocation,
      zhTWMaintenance, zhTWAnnouncement, zhTWUpdateLog, zhTWPayment, zhTWSystem
    )
  },
  'en-US': {
    translation: Object.assign(
      {},
      enCommon, enAuth, enNavigation, enVendor, enUser,
      enDashboard, enMachine, enProduct, enOrder, enLocation,
      enMaintenance, enAnnouncement, enUpdateLog, enPayment, enSystem
    )
  },
  'es-ES': {
    translation: Object.assign(
      {},
      esESCommon, esESAuth, esESNavigation, esESVendor, esESUser,
      esESDashboard, esESMachine, esESProduct, esESOrder, esESLocation,
      esESMaintenance, esESAnnouncement, esESUpdateLog, esESPayment, esESSystem
    )
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-TW',
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    }
  });

export default i18n;
